export default "__VITE_ASSET__CwN27cuX__"